export default __webpack_public_path__ + "static/media/dra-ivani.8373fb7f.png";